import axios from "axios";
import { FlaskReq } from "helpers/Request";

export function setCustomerList(customers) {
  return {
    type: "CUSTOMER_LIST",
    payload: { customers }
  };
}

export function setPartList(parts) {
  return {
    type: "PART_LIST",
    payload: { parts }
  };
}

export function setPartAdded(part) {
  return {
    type: "ADD_PART",
    payload: { ...part, type: "P", quantity: 1 }
  };
}

export function getCustomerList(url, source = {}) {
  return dispatch => {
    return FlaskReq({
      url: `${localStorage.flask_url}/${url}`,
      method: "get",
      cancelToken: source.token
    }).then(res => {
      const { customers } = res.data;
      dispatch(setCustomerList(customers));
      return res;
    });
  };
}

export function getWarehouses(url) {
  return dispatch => {
    return axios.get(url).then(res => {
      return res.data.results;
    });
  };
}

export function changeSingleCustomer() {
  return {
    type: "CHANGE_SINGLE_CUSTOMER",
    payload: {
      showSingleCustomer: false
    }
  };
}

export function getSingleCustomer(id) {
  return {
    type: "GET_SINGLE_CUSTOMER",
    id
  };
}

export function setSingleCustomer(customerNumber, customer) {
  return dispatch => {
    let baseUrl = `${localStorage.flask_url}/customers/${encodeURIComponent(
      customerNumber
    )}/sites`;
    const config = {
      url: baseUrl,
      method: "get"
    };
    return FlaskReq(config).then(response => {
      if (response.data.sites.length > 0) {
        dispatch({
          type: "FETCH_SITES_FROM_SRM",
          value: {
            customerSitesFromSRM: response.data
          }
        });
      }
      if (customer !== undefined) {
        return dispatch({
          type: "SET_SINGLE_CUSTOMER",
          customer
        });
      }
      return FlaskReq({
        url: `${localStorage.flask_url}/customers/${customerNumber}`,
        method: "get"
      }).then(res => {
        const customer = res.data;
        dispatch({
          type: "SET_SINGLE_CUSTOMER",
          customer
        });
      });
    });
  };
}

export function getSingleAsset(asset) {
  return {
    type: "GET_SINGLE_ASSET",
    asset
  };
}

export function addPart(part) {
  return dispatch => {
    dispatch(setPartAdded(part));
  };
}

export function addMessage(message, toTop) {
  if (toTop !== undefined && toTop) {
    window.scrollTo(0, 0);
  }
  return {
    type: "ADD_MESSAGE",
    message
  };
}

export function deleteMessage() {
  return {
    type: "DELETE_MESSAGE"
  };
}

export function addNewSite(values) {
  return {
    type: "ADD_NEW_SITE",
    payload: values
  };
}
